/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import { Button } from "../../../components";
import { Modal } from "../../../components/Modal/Modal";
import LineItemContent from "./LineItemCaptureModalContent";
import LineItemDisplay from "./LineItemDisplay";
import { IProduct } from "../../../types";
import LineItemDeleteModalContent from "./LineItemDeleteModalContent";
import { getTotalAmountForLineItem, getTotalAmountForLineItemArray } from "../../../utils/Calculation";
import { useSelector } from "react-redux";

type LineItemData = {
  lineItems: Array<IProduct>;
};

export interface LineItemInputFormProps {
  canProceed: any;
  data: any;
  updateData: (fields: Partial<LineItemData>) => void;
}

const DEFAULT_PAYMENT_LIMIT = 8000000;

const LineItemInputForm = ({ canProceed, data, updateData }: LineItemInputFormProps) => {
  const [isAddModalOpen, setAddModalOpen] = useState(false);
  const [isEditModalOpen, setEditModalOpen] = useState(false);
  const [lineItemEditDeleteIndex, setLineItemEditDeleteIndex] = useState(0);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const { lineItems } = data;
  const merchant = useSelector(
    // @ts-ignore
    state => state.authenticationReducer.merchantDetails,
  );

  const setCanProceed = (arr: Array<LineItemData>) => {
    if (arr.length > 0) canProceed(true);
    else canProceed(false);
  };

  setCanProceed(lineItems);

  const addLineItem = (lineItem: IProduct) => {
    const id = Math.random() * 100000;
    const updatedLineItems = [...lineItems, { ...lineItem, id }];
    setCanProceed(updatedLineItems);
    updateData({ lineItems: updatedLineItems });
    setAddModalOpen(false);
  };

  const editLineItem = (lineItem: IProduct) => {
    const copyLineItems = lineItems.slice();
    copyLineItems.splice(lineItemEditDeleteIndex, 1, lineItem);
    updateData({ lineItems: copyLineItems });
    setEditModalOpen(false);
  };

  const deleteLineItem = () => {
    const copyLineItems = lineItems.slice();
    copyLineItems.splice(lineItemEditDeleteIndex, 1);
    setCanProceed(copyLineItems);
    updateData({ lineItems: copyLineItems });
    setDeleteModalOpen(false);
  };

  const cancelDelete = () => {
    setDeleteModalOpen(false);
  };

  const cancelEdit = () => {
    setEditModalOpen(false);
  };

  return (
    <div className="line-item-page">
      <div className="add-item-button-container">
        <Button
          type="button"
          className="w-100 text-medium text-size-16"
          label="Add Line Item"
          onClick={() => {
            setAddModalOpen(true);
          }}
          size="medium"
          varient="secondary"
        />{" "}
      </div>

      <LineItemDisplay
        onLineItemSelect={(index: number) => setLineItemEditDeleteIndex(index)}
        lineItemInformation={lineItems}
        onEditLineItem={() => setEditModalOpen(true)}
        onDeleteLineItem={() => setDeleteModalOpen(true)}
      />

      <Modal
        title="Add line item"
        isOpen={isAddModalOpen}
        content={
          <LineItemContent
            lineItemTally={getTotalAmountForLineItemArray(lineItems)}
            lineItem={{} as IProduct}
            onCancel={() => setAddModalOpen(false)}
            onSubmit={(lineItem: IProduct) => addLineItem(lineItem)}
            paymentLimit={merchant.ecommLimitOverride || DEFAULT_PAYMENT_LIMIT}
          />
        }
      />

      <Modal
        title="Edit line item"
        isOpen={isEditModalOpen}
        content={
          <LineItemContent
            lineItemTally={
              getTotalAmountForLineItemArray(lineItems) - getTotalAmountForLineItem(lineItems[lineItemEditDeleteIndex] || 0)
            }
            lineItem={lineItems[lineItemEditDeleteIndex]}
            onCancel={cancelEdit}
            onSubmit={(lineItem: IProduct) => editLineItem(lineItem)}
            paymentLimit={merchant.ecommLimitOverride || DEFAULT_PAYMENT_LIMIT}
          />
        }
      />

      <Modal
        isOpen={deleteModalOpen}
        content={<LineItemDeleteModalContent onCancel={cancelDelete} onDelete={deleteLineItem} />}
      />
    </div>
  );
};

export default LineItemInputForm;
